export const UPDATE_NOTICE_LANGUAGES = [
  { code: 'ko', label: '한국어' },
  { code: 'en', label: 'English' },
  { code: 'tr', label: 'Türkçe' },
  { code: 'pt', label: 'Português' },
  { code: 'hi', label: 'हिन्दी' },
  { code: 'es', label: 'Español' },
  { code: 'de', label: 'Deutsch' },
  { code: 'zh', label: '中文' },
  { code: 'it', label: 'Italiano' },
  { code: 'pl', label: 'Polski' },
  { code: 'cs', label: 'Čeština' },
  { code: 'uk', label: 'Українська' },
  { code: 'uz', label: 'O‘zbekcha' },
];

const LANGUAGE_CODES = new Set(
  UPDATE_NOTICE_LANGUAGES.map(({ code }) => code),
);

const LANGUAGE_ALIASES = {
  kr: 'ko',
  sp: 'es',
  ge: 'de',
  ch: 'zh',
  po: 'pl',
  cz: 'cs',
};

export function normalizeUpdateNoticeLanguage(value, fallback = 'ko') {
  const normalized = String(value || '')
    .trim()
    .toLowerCase()
    .replace('_', '-');

  const shortCode = normalized.split('-')[0];
  const resolvedCode = LANGUAGE_ALIASES[shortCode] || shortCode;

  if (LANGUAGE_CODES.has(resolvedCode)) {
    return resolvedCode;
  }

  const normalizedFallback = String(fallback || 'ko')
    .trim()
    .toLowerCase()
    .split('-')[0];

  const resolvedFallback =
    LANGUAGE_ALIASES[normalizedFallback] || normalizedFallback;

  return LANGUAGE_CODES.has(resolvedFallback)
    ? resolvedFallback
    : 'ko';
}

export function formatNoticeDate(value) {
  const text = String(value || '').trim();

  if (!text) {
    return '-';
  }

  const normalized = text.replace(/[./]/g, '-');
  const date = new Date(normalized);

  if (Number.isNaN(date.getTime())) {
    return text;
  }

  return new Intl.DateTimeFormat('ko-KR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date);
}

export function getNoticeTitle(notice) {
  return String(notice?.title || '').trim() || '-';
}

export function getNoticeOverview(notice) {
  return String(notice?.overview || '').trim();
}
